export default {
  departments: [],
  members: {},
  isGettingMembers: false,
};
